import React, { useContext } from 'react';
import { observer } from 'mobx-react';

import { AuthContext } from 'core/components/auth';
import { FormField } from 'core/components/form';
import { Label } from 'core/components/label';
import { Button } from 'core/components/button';
import { withToast } from 'core/components/toast';
import { useStore } from 'core/store/store.mobx';

import TroubleshootingToggle from './troubleshooting-toggle';
import useStyles from '../footer.styles';

// Subtitle under the "Update Offer" title, shown only when the agent has
// unsaved edits, so they know pressing Update will apply those edits
// (#30230 follow-up).
//
// We intentionally say nothing in the purely stale case (offer's rate control
// date is 1-29 days old). Earlier copy explained the stale re-rate to agents,
// but agency agents read "pricing is out of date" / "recalculate" as Branch
// changing their price and coverage behind their back, which generated
// consistent negative feedback (#31893). The plain "Update Offer" title is
// enough there. The subtitle exists only to surface the one thing the title
// doesn't already imply: that the agent's own edits will be applied. When an
// offer is both stale and dirty we still show only the edits copy.
const UpdateReasonCopy = {
  dirty: 'Updating will apply the changes you made to this offer.',
  both: 'Updating will apply the changes you made to this offer.'
};

const UpdateOffer = observer(({ onUpdate, updateReason }) => {
  const { offer: store } = useStore();
  const classes = useStyles();

  const session = useContext(AuthContext);
  const showOverrideCheckbox = !session.isAgency && session.username !== store.offer?.quote?.rep;

  const subtitle = updateReason ? UpdateReasonCopy[updateReason] : null;

  return (
    <>
      <div className={classes.titleContainer}>
        <Label className={classes.title} type="subtitle">
          Update Offer
        </Label>
        {subtitle && (
          <Label className={classes.subtitle} type="subtitle">
            {subtitle}
          </Label>
        )}
      </div>
      <div className={classes.updateActions}>
        {showOverrideCheckbox && (
          <FormField
            mode="light"
            name="dontOverwriteRep"
            label="Don't overwrite rep"
            type="checkbox"
            className={classes.checkbox}
          />
        )}
        <TroubleshootingToggle />
        <Button
          onClick={onUpdate}
          disabled={store.loading}
          loading={store.loading}
          variant="contained"
          color="primary"
          className={classes.btn}
        >
          <Label className={classes.btnLabel}>Update Offer Price</Label>
        </Button>
      </div>
    </>
  );
});
export default withToast(UpdateOffer);
